export const actSuggestions = {
  16: '16 or lower',
  17: '17',
  18: '18',
  19: '19',
  20: '20',
  21: '21',
  22: '22',
  23: '23',
  24: '24',
  25: '25',
  26: '26',
  27: '27',
  28: '28',
  29: '29',
  30: '30',
  31: '31',
  32: '32',
  33: '33',
  34: '34',
  35: '35',
  36: '36',
};

export const states = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington D.C',
  WN: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

export const statesArray = [
  'All States',
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa', 'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana', 'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma', 'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington D.C',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];

export const positions = {
  QBDT: 'Quarterback - Duel Threat',
  QBPS: 'Quarterback - Pro Style',
  WR: 'Wide Receiver',
  SR: 'Slot Receiver',
  RB: 'Running Back',
  FB: 'Full Back',
  HB: 'H-Back',
  TE: 'Tight End',
  OG: 'Offensive Guard',
  OT: 'Offensive Tackle',
  C: 'Center',
  DT: 'Defensive Tackle',
  DE: 'Defensive End',
  ML: 'Middle Linebacker',
  OL: 'Outside Linebacker',
  DB: 'Cornerback',
  SS: 'Strong Safety',
  FS: 'Free Safety',
  K: 'Kicker',
  P: 'Punter',
  LS: 'Long Snapper',
};

export const positionsArray = [
  'All Positions',
  'Quarterback - Duel Threat',
  'Quarterback - Pro Style',
  'Wide Receiver',
  'Slot Receiver',
  'Running Back',
  'Full Back',
  'H-Back',
  'Tight End',
  'Offensive Guard',
  'Offensive Tackle',
  'Center',
  'Defensive Tackle',
  'Defensive End',
  'Middle Linebacker',
  'Outside Linebacker',
  'Cornerback',
  'Strong Safety',
  'Free Safety',
  'Kicker',
  'Punter',
  'Long Snapper',
];

export const offensivePositions = {
  QBDT: 'Quarterback - Duel Threat',
  QBPS: 'Quarterback - Pro Style',
  WR: 'Wide Receiver',
  SR: 'Slot Receiver',
  RB: 'Running Back',
  FB: 'Full Back',
  HB: 'H-Back',
  TE: 'Tight End',
  OG: 'Offensive Guard',
  OT: 'Offensive Tackle',
  C: 'Center',
};

export const defensivePositions = {
  DT: 'Defensive Tackle',
  DE: 'Defensive End',
  ML: 'Middle Linebacker',
  OL: 'Outside Linebacker',
  DB: 'Cornerback',
  SS: 'Strong Safety',
  FS: 'Free Safety',

};

export const specialTeamsPositions = {
  K: 'Kicker',
  P: 'Punter',
  LS: 'Long Snapper',
};

export const positionNames = {
  QBDT: 'primary_offensive_position_pref',
  QBPS: 'primary_offensive_position_pref',
  WR: 'primary_offensive_position_pref',
  SR: 'primary_offensive_position_pref',
  RB: 'primary_offensive_position_pref',
  FB: 'primary_offensive_position_pref',
  HB: 'primary_offensive_position_pref',
  TE: 'primary_offensive_position_pref',
  OG: 'primary_offensive_position_pref',
  OT: 'primary_offensive_position_pref',
  C: 'primary_offensive_position_pref',
  DT: 'primary_defensive_position_pref',
  DE: 'primary_defensive_position_pref',
  ML: 'primary_defensive_position_pref',
  OL: 'primary_defensive_position_pref',
  DB: 'primary_defensive_position_pref',
  SS: 'primary_defensive_position_pref',
  FS: 'primary_defensive_position_pref',
};

export const divisions = {
  D1: 'D1',
  D2: 'D2',
  D3: 'D3',
  JUCO: 'JUCO',
  NAIA: 'NAIA',
};

export const allYears = [
  'All Years',
  '2014',
  '2015',
  '2016',
  '2017',
  '2018',
  '2019',
  '2020',
];

export const allGpa = [
  'Minimum Gpa 4.0',
  'Minimum Gpa 3.9',
  'Minimum Gpa 3.8',
  'Minimum Gpa 3.7',
  'Minimum Gpa 3.6',
  'Minimum Gpa 3.5',
  'Minimum Gpa 3.4',
  'Minimum Gpa 3.3',
  'Minimum Gpa 3.2',
  'Minimum Gpa 3.1',
  'Minimum Gpa 3.0',
  'Minimum Gpa 2.9',
  'Minimum Gpa 2.8',
  'Minimum Gpa 2.7',
  'Minimum Gpa 2.6',
  'Minimum Gpa 2.5',
  'Minimum Gpa 2.4',
  'Minimum Gpa 2.3',
  'Minimum Gpa 2.2',
  'Minimum Gpa 2.1',
  'Minimum Gpa 2.0 or lower',
];

export const gpaKey = {
  4.0: 'Minimum Gpa 4.0',
  3.9: 'Minimum Gpa 3.9',
  3.8: 'Minimum Gpa 3.8',
  3.7: 'Minimum Gpa 3.7',
  3.6: 'Minimum Gpa 3.6',
  3.5: 'Minimum Gpa 3.5',
  3.4: 'Minimum Gpa 3.4',
  3.3: 'Minimum Gpa 3.3',
  3.2: 'Minimum Gpa 3.2',
  3.1: 'Minimum Gpa 3.1',
  3.0: 'Minimum Gpa 3.0',
  2.9: 'Minimum Gpa 2.9',
  2.8: 'Minimum Gpa 2.8',
  2.7: 'Minimum Gpa 2.7',
  2.6: 'Minimum Gpa 2.6',
  2.5: 'Minimum Gpa 2.5',
  2.4: 'Minimum Gpa 2.4',
  2.3: 'Minimum Gpa 2.3',
  2.2: 'Minimum Gpa 2.2',
  2.1: 'Minimum Gpa 2.1',
  2.0: 'Minimum Gpa 2.0 or lower',
};

export const pagination = [
  'Top 20',
  'Top 50',
  'Top 100',
];

export const paginationKey = [
  20,
  50,
  100,
];



// WEBPACK FOOTER //
// ./src/common/constants/DropdownsValues.js